import React from 'react'
import { asoleacionData } from '../../../data/asoleacion.data';

interface AsoleacionUI {
    inputRef: any
}

interface Props{
    isAsoleacionActive: boolean,
    currentVideoDuration: number,
    handleChangeVideoTime: any
    handleChangeVista: any,
    handlePlayVideo: any,
    currentIndexVista: number
}

interface State{}

class AsoleacionUI extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {}

        this.inputRef = React.createRef()
    }

    handleCreateVistasStructure = () => {
        return(
            Object.keys(asoleacionData()[0]["asoleacion"][0].vistas).map((elem: any, index: number) => 
                <div className={this.props.currentIndexVista === index ? 'vista-individual vista-selected':'vista-individual'} onClick={() => {this.props.handleChangeVista(elem)}}>
                    {elem}
                </div>
            )
        )
    }

    handleCreateHoursStructure = () => {
        return(
            asoleacionData()[0]["asoleacion"][0].hours.map((elem: any, index: number) => 
                <div className='vista-individual' onClick={() => {this.props.handleChangeVista(elem)}}>
                    <img src={elem.image.default} alt=""/>
                </div>
            )
        )
    }

    render(): React.ReactNode {
        return(
            <div className={this.props.isAsoleacionActive ? 'asoleacion-ui-container fade-in':'asoleacion-ui-container fade-out'}>
                <div className='module-title'>{"Asoleación".toLocaleUpperCase()}</div>
                <div className='slider-container'>
                    <div className='buttons-container'>
                        {
                            this.handleCreateHoursStructure()
                        }
                    </div>
                    <div className='input-container'>
                        <input type="range" min={0} max={this.props.currentVideoDuration} step={0.05} onChange={(e) => {this.props.handleChangeVideoTime(e)}} ref={this.inputRef}/>
                    </div>
                </div>
                <div onClick={() => {this.props.handlePlayVideo()}} className="auto-asoleacion">
                    Animación automática
                </div>
                <div className='vistas-container'>
                    <div className='vistas-title'>VISTAS</div>
                    {
                        this.handleCreateVistasStructure()
                    }
                </div>
            </div>
        )
    }
}

export default AsoleacionUI